<template>
    <div class="customer-settings">
      <div class = "top-config standard-padding">
        <h2>CustomerSettings</h2>

        <template v-if="documentSearchParams.customerId == 70">
            <table>
                <tr>
                    <td>YTunnus</td>
                    <td>Company name</td>
                    <td>Category</td>
                </tr>
                <tr>
                    <td><input v-model="finlandMailRoomToAdd.orgNo"></td>
                    <td><input v-model="finlandMailRoomToAdd.companyName"></td>
                    <td><input v-model="finlandMailRoomToAdd.category"></td>
                    <td><button @click="add()">Add</button></td>
                </tr>
            </table>
            <button @click="load()">Search</button>
            <table v-if="documentSearchParams.customerId === 70">
            <tr v-for="c in finlandMailRoom.companies" v-bind:key="c.orgNo">
                <td><input v-model="c.orgNo" /></td>
                <td><input v-model="c.companyName"></td>
                <td><input v-model="c.category"></td>
                <td><button @click="save(c)">Update</button></td>
                <td><button @click="del(c)">Delete</button></td>
            </tr>
            </table>
        </template>
        <template v-else-if="documentSearchParams.customerId == 69">
          <uppsala-vatten/>
        </template>
        
      </div>
    </div>
  </template>
  
  
  <script>
  import $ from 'jquery'
import UppsalaVatten from '../components/ImportAndExport/UppsalaVatten.vue'
  
  export default {
    name: 'customer-settings',
    components: {
        UppsalaVatten
    },
    computed: {
      finlandMailRoom () {
        return this.$store.state.finlandMailRoom
      },
      finlandMailRoomToAdd () {
        return this.$store.state.finlandMailRoomToAdd
      },
      documentSearchParams() {
        return this.$store.state.documentSearchParams
      },

    },
    methods: {
     save (data){
      var _this = this;
      this.$store.dispatch('saveFinlandMailRoom', {data: data}).then( () => {      
        _this.load();
      }).catch(error => {
        console.log(error)
      })
     },
     del (data){
      var _this = this;
      this.$store.dispatch('deleteFinlandMailRoom', {data: data}).then( () => {      
        _this.load();
      }).catch(error => {
        console.log(error)
      })
     },
     add (){
      var _this = this;
      this.$store.dispatch('addFinlandMailRoom', {data: this.finlandMailRoomToAdd}).then( () => {      
        this.finlandMailRoomToAdd.orgNo = "";
        this.finlandMailRoomToAdd.companyName = "";
        this.finlandMailRoomToAdd.category = "";
        _this.load();
      }).catch(error => {
        console.log(error)
      })
     },
     load(){
      var _this = this;
        this.$store.dispatch('loadFinlandMailRoom').then( () => {        
      }).catch(error => {
        console.log(error)
      })
     }
    }
  }
  
  </script>
  
  <style scoped>
  
  .customer-config{
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
  
  .bottom-config{
    flex: auto;
    overflow-y: auto;
  }
  
  
  .center-aligned
  {
    text-align: center;
  }
  
  textarea
  {
    width: 80vw;
    height: 50vh;
    white-space: nowrap;  overflow: auto;
    float: left;
  }
  
  
  
  
  input, select{
    /*min-width: 300px;
    width: 300px;*/
  }
  
  label{
    padding-right: 10px;
    padding-left: 20px;
  }
  
  
  </style>
  